import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmputils" id="xmputils"></a>
    <h1 {...{
      "id": "requireuxpxmpxmputils"
    }}>{`require('uxp').xmp.XMPUtils`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0  `}</p>
    <a name="new-xmputils-new" id="new-xmputils-new"></a>
    <h2 {...{
      "id": "xmputils"
    }}>{`XMPUtils()`}</h2>
    <p>{`This class provides additional utility functions for the XMP Toolkit, layered upon the functionality of
the `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`. It has only static functions, you cannot create an instance.`}</p>
    <p>{`Path-composition functions such as composeArrayItemPath(), provide support for composing path
expressions to deeply nested properties, which you can then pass to the accessor functions in
`}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`, such as xmpmetaobj-getProperty.`}</p>
    <p>{`Higher-level functions such as xmputils-duplicateSubtree allow you to manipulate the metadata tree
in an `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`.`}</p>
    <a name="xmputils-appendproperties" id="xmputils-appendproperties"></a>
    <h2 {...{
      "id": "appendpropertiessource-dest-options"
    }}>{`appendProperties(source, dest, `}{`[options]`}{`)`}</h2>
    <p>{`Copies properties from a source `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{` and appends them to a destination `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`source`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The source `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dest`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The destination `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Option flags that control the copying operation. A logical OR of these bit-flag constants:`}<br></br>{` - XMPConst.APPEND_ALL_PROPERTIES: Include both internal and external properties. By default, copies only external properties. This applies only to top-level properties.`}<br></br>{` - XMPConst.APPEND_REPLACE_OLD_VALUES: Replace the values of existing properties with the value from the source object. By default, existing values are retained. This applies to properties at all levels of hierarchy.`}<br></br>{` - XMPConst.APPEND_DELETE_EMPTY_VALUES: Delete properties if the new value is empty.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.appendProperties(source, dest, options)
`}</code></pre>
    <a name="xmputils-catenatearrayitems" id="xmputils-catenatearrayitems"></a>
    <h2 {...{
      "id": "catenatearrayitemsxmpobj-schemans-arrayname-separator-quotes--options"
    }}>{`catenateArrayItems(xmpObj, schemaNS, arrayName, `}{`[separator]`}{`, `}{`[quotes `}{`=]`}{`, `}{`[options]`}{`)`}</h2>
    <p>{`Concatenates a set of array item values into a single string. The resulting string can be separated back out into array items using separateArrayItems().`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the concatenated string.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpObj`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{` containing the array.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array property name string. Can be a general path expression. Each item in the array must be a simple string value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[separator]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The string used to separate the items in the result string. Default is ‘; ‘, an ASCII semicolon and space (U+003B,U+0020).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[quotes =]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The character used to quote items that contain a separator. Default is ‘”’, an ASCII double quote (U+0022).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Option flag that controls the concatenation. This constant value:`}<br></br>{` - XMPConst.SEPARATE_ALLOW_COMMAS: Allow commas in item values (such as “LastName, FirstName”). This option must be set the same way in this function and in `}<a parentName="td" {...{
              "href": "#separatearrayitemsxmpobj-schemans-arrayname-arrayoptions-concatstring"
            }}>{`separateArrayItems()`}</a>{` to reconstruct the items correctly.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.catenateArrayItems(xmpObj, schemaNS, arrayName, separator, quotes, options)
`}</code></pre>
    <a name="xmputils-composearrayitempath" id="xmputils-composearrayitempath"></a>
    <h2 {...{
      "id": "composearrayitempathschemans-arrayname-itemindex"
    }}>{`composeArrayItemPath(schemaNS, arrayName, itemIndex)`}</h2>
    <p>{`Creates and returns a string containing the path expression for an item in an array, using the registered prefix for the namespace, in the form:
schemaNS:arrayName`}{`[itemIndex]`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the path expression for an item in an array.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`itemIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The 1-based position index of the item. Use XMPConst.ARRAY_LAST_ITEM to reference the last existing item in the array. In this case, the resulting path is ns:arrayName`}{`[last()]`}{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.composeArrayItemPath(schemaNS, arrayName, itemIndex)
`}</code></pre>
    <a name="xmputils-composefieldselector" id="xmputils-composefieldselector"></a>
    <h2 {...{
      "id": "composefieldselectorschemans-arrayname-fieldns-fieldname-fieldvalue"
    }}>{`composeFieldSelector(schemaNS, arrayName, fieldNS, fieldName, fieldValue)`}</h2>
    <p>{`Creates and returns a string containing the path expression to select an alternate item by a field’s value, using the registered prefixes for the namespaces, in the form:
schemaNS:arrayName`}{`[fieldNS:fieldName='fieldValue']`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the path expression to select an alternate item by a field’s value.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field namespace URI string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name. Must be a simple XML name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The desired field value.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.composeFieldSelector(schemaNS, arrayName, fieldNS, fieldName, fieldValue)
`}</code></pre>
    <a name="xmputils-composelangselector" id="xmputils-composelangselector"></a>
    <h2 {...{
      "id": "composelangselectorschemans-arrayname-locale"
    }}>{`composeLangSelector(schemaNS, arrayName, locale)`}</h2>
    <p>{`Creates and returns a string containing the path expression to select an alternate item in an alt text array by language, using the registered prefix for the namespace, in the form:
schemaNS:arrayName`}{`[@xml:lang='langName']`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the path expression to select an alternate item in an alt text array by language.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Note`}</strong>{`: Do not use this in place of getLocalizedText() or setLocalizedText().
Those functions provide extra logic to choose the appropriate language and maintain consistency with the x-default value.
This function provides a path expression for an explicit language, and only for that language.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`locale`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The RFC3066 locale code string for the desired language.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.composeLanguageSelector(schemaNS, arrayName, locale)
`}</code></pre>
    <a name="xmputils-composestructfieldpath" id="xmputils-composestructfieldpath"></a>
    <h2 {...{
      "id": "composestructfieldpathschemans-structname-fieldns-fieldname"
    }}>{`composeStructFieldPath(schemaNS, structName, fieldNS, fieldName)`}</h2>
    <p>{`Creates and returns a string containing the path expression for a field in a structure, using the registered prefixes for the namespaces, in the form:
schemaNS:structName/fieldNS:fieldName`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the path expression for a field in a structure.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`structName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The structure property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field namespace URI string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fieldName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The field name. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.composeStructFieldPath(schemaNS, structName, fieldNS, fieldName)
`}</code></pre>
    <a name="xmputils-composequalifierpath" id="xmputils-composequalifierpath"></a>
    <h2 {...{
      "id": "composequalifierpathschemans-propname-qualns-qualname"
    }}>{`composeQualifierPath(schemaNS, propName, qualNS, qualName)`}</h2>
    <p>{`Creates and returns a string containing the path expression for a qualifier attached to a property, using the registered prefix for the namespace, in the form:
schemaNS:propName/?qualNS:qualName`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a string containing the path expression for a qualifier attached to a property.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The qualifier namespace URI string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`qualName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The qualifier name. Must be a simple XML name.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.composeQualifierPath(schemaNS, propName, qualNS, qualName)
`}</code></pre>
    <a name="xmputils-duplicatesubtree" id="xmputils-duplicatesubtree"></a>
    <h2 {...{
      "id": "duplicatesubtreesource-dest-sourcens-sourceroot-destns-destroot-options"
    }}>{`duplicateSubtree(source, dest, sourceNS, sourceRoot, destNS, `}{`[destRoot]`}{`, `}{`[options]`}{`)`}</h2>
    <p>{`Copies properties in the specified subtree from a source `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{` and adds them into a destination `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`source`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The source `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dest`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The destination `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sourceNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The source namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sourceRoot`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string for the root location of the source subtree. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`destNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The destination namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[destRoot]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string for the root location of the destination subtree. Can be a general path expression. Default is the source root location.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Option flags that control the copying operation. A logical OR of these bit-flag constants:`}<br></br>{` - XMPConst.APPEND_ALL_PROPERTIES: Include both internal and external properties. By default, copies only external properties. This applies only to top-level properties.`}<br></br>{` - XMPConst.APPEND_REPLACE_OLD_VALUES: Replace the values of existing properties with the value from the source object. By default, existing values are retained. This applies to properties at all levels of hierarchy.`}<br></br>{` - XMPConst.APPEND_DELETE_EMPTY_VALUES: Delete properties if the new value is empty.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.duplicateSubtree(source, dest, sourceNS, sourceRoot, destNS, destRoot, options)
`}</code></pre>
    <a name="xmputils-removeproperties" id="xmputils-removeproperties"></a>
    <h2 {...{
      "id": "removepropertiesxmpobj-schemans-propname-options"
    }}>{`removeProperties(xmpObj, `}{`[schemaNS]`}{`, `}{`[propName]`}{`, `}{`[options]`}{`)`}</h2>
    <p>{`Removes multiple properties from an `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{`.`}<br></br><br></br>{`
If both the namespace and property name are supplied, removes the property if it is external, even if it is an alias.`}<br></br>{`
If it is internal, removes it if the option XMPConst.REMOVE_ALL_PROPERTIES is specified.`}<br></br><br></br>{`
If the namespace is supplied and the property name is not, removes all external properties in the namespace,`}<br></br>{`
and optionally all internal properties. Removes aliases only if the option XMPConst.REMOVE_INCLUDE_ALIASES is specified.`}<br></br><br></br>{`
If neither the namespace nor the property name are supplied, removes all external properties, and optionally all internal properties.`}<br></br>{`
Aliases are handled implicitly, because the associated actual is removed.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpObj`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[schemaNS]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`. Must be supplied if a property name is supplied.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[propName]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The property name string. Can be a general path expression.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Option flags that control the deletion operation. A logical OR of these bit-flag constants:`}<br></br>{` - XMPConst.REMOVE_ALL_PROPERTIES: Remove internal and external properties. By default, removes only external properties. Applies only to top-level properties.`}<br></br>{` - XMPConst.REMOVE_INCLUDE_ALIASES: Remove aliases defined in the namespace. If the property name is supplied, removes it regardless of this option.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.removeProperties(xmpObj, schemaNS, propName, options)
`}</code></pre>
    <a name="xmputils-separatearrayitems" id="xmputils-separatearrayitems"></a>
    <h2 {...{
      "id": "separatearrayitemsxmpobj-schemans-arrayname-arrayoptions-concatstring"
    }}>{`separateArrayItems(xmpObj, schemaNS, arrayName, `}{`[arrayOptions]`}{`, concatString)`}</h2>
    <p>{`Updates individual array item strings in the `}<a parentName="p" {...{
        "href": "./XMPMeta.md"
      }}>{`XMPMeta object`}</a>{` from a concatenated string returned by catenateArrayItems().
Recognizes a large set of separator characters, including semicolons, commas, tab, return, linefeed, and multiple spaces.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpObj`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPMeta`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<a parentName="td" {...{
              "href": "./XMPMeta.md"
            }}>{`XMPMeta object`}</a>{` containing the array.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`schemaNS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The namespace URI string. See `}<a parentName="td" {...{
              "href": "./XMPConst.md#schema-namespace-string-constants"
            }}>{`Schema namespace string constants`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`arrayName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The array property name string. Can be a general path expression. Each item in the array must be a simple string value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[arrayOptions]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Option flags that control how the array property is updated from the separated string. A logical OR of these bit-flag constants:`}<br></br>{` - XMPConst.APPEND_ALL_PROPERTIES: Include both internal and external properties. By default, copies only external properties. This applies only to top-level properties.`}<br></br>{` - XMPConst.APPEND_REPLACE_OLD_VALUES: Replace the values of existing properties with the value from the source object. By default, existing values are retained. This applies to properties at all levels of hierarchy.`}<br></br>{` - XMPConst.APPEND_DELETE_EMPTY_VALUES: Delete properties if the new value is empty.`}<br></br>{` - XMPConst.SEPARATE_ALLOW_COMMAS: Allow commas in item values. If not specified, an item containing a comma (such as “LastName, FirstName”) is separated into two array items.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`concatString`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The string containing the concatenated array values, as returned by catenateArrayItems().`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`XMPUtils.separateArrayItems(xmpObj, schemaNS, arrayName, arrayOptions, concatString)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      